import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const items = [
  { path: "/sectores/proceso_productivo", label: "Proceso productivo", color: "#585858" },
  { path: "/sectores/control_de_calidad", label: "Control de calidad", color: "#FFEC00" },
  { path: "/sectores/diseno_y_desarrollo", label: "Diseño y desarrollo", color: "#00B1E8" },
  { path: "/sectores/sustentabilidad", label: "Sustentabilidad", color: "#96C11E" },
];

function SectoresSubnav() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const navRef = useRef(null);
  const toggleRef = useRef(null);
  const current = items.find(item => item.path === location.pathname) || items[0];

  useEffect(() => setIsOpen(false), [location.pathname]);
  useEffect(() => {
    if (!isOpen) return;
    const onKey = event => {
      if (event.key === "Escape") {
        setIsOpen(false);
        toggleRef.current?.focus();
      }
    };
    const onPointer = event => {
      if (!navRef.current?.contains(event.target)) setIsOpen(false);
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("pointerdown", onPointer);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("pointerdown", onPointer);
    };
  }, [isOpen]);

  return (
    <>
      <div style={{ height: "var(--nav-height)" }} aria-hidden="true" />
      <nav ref={navRef} aria-label="Sectores" className={`sticky z-30 w-full shadow ${current === items[0] ? "text-white" : "text-[#252528]"}`}
        style={{ backgroundColor: current.color, top: "var(--nav-height)" }}>
        <div className="relative mx-auto max-w-6xl px-4">
          <button ref={toggleRef} type="button" onClick={() => setIsOpen(open => !open)}
            className="md:hidden flex items-center justify-between w-full min-h-12 gap-4 font-gotham text-sm"
            aria-expanded={isOpen} aria-controls="sectores-menu">
            {current.label}
            <span aria-hidden="true" className={`transition-transform ${isOpen ? "rotate-180" : ""}`}>⌄</span>
          </button>
          <ul id="sectores-menu" className={`${isOpen ? "block animate-fade-up" : "hidden"} md:flex absolute md:static top-full left-0 w-full shadow-lg md:shadow-none rounded-b-xl md:rounded-none overflow-hidden`}
            style={{ backgroundColor: current.color }}>
            {items.map(item => (
              <li key={item.path} className="md:flex-1">
                <Link to={item.path} onClick={() => setIsOpen(false)} aria-current={current.path === item.path ? "page" : undefined}
                  className={`block px-4 py-4 text-sm text-left md:text-center font-gotham transition-colors hover:bg-black/10 ${current.path === item.path ? "font-bold underline underline-offset-8 bg-black/5" : "font-medium"}`}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </>
  );
}

export default SectoresSubnav;
